if(!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();

      this._internals = this.attachInternals();

      this.elOptions = this.querySelectorAll('[data-option]');
      this.elToggle = this.querySelector('[data-toggle]');
      this.elSelected = this.querySelector('[data-selected]');
      this.elModal = this.querySelector('popup-modal');

      this.currentOption = [...this.elOptions].find(el => el.checked);

      this.setHeight();

      this.elToggle.addEventListener('click', this.toggleSelect.bind(this));
      this.elOptions.forEach(el => {
        el.addEventListener('change', this.setCurrentOption.bind(this));
      })
    }

    setCurrentOption({ currentTarget }) {
      this.currentOption = currentTarget;
      this.elSelected.innerHTML = this.currentOption.labels[0].innerHTML;
      this.toggleSelect();
    }

    toggleSelect() {
      const isOpen = this._internals.states.has('open');
      isOpen ? this._internals.states.delete('open') : this._internals.states.add('open');
      this.elModal.setAttribute('open', !isOpen);
    }

    setHeight() {
      this._internals.states.delete('loaded');

      setTimeout(() => {
        const { height: modalHeight } = this.elModal.getBoundingClientRect();
        const { height: toggleHeight } = this.elToggle.getBoundingClientRect();

				this.style.setProperty('--open-height', `${modalHeight + toggleHeight}px`);
        this.style.setProperty('--closed-height', `${toggleHeight}px`);
			}, 300);

			setTimeout(() => {
				this._internals.states.add('loaded');
			}, 500);
    }
  }
  customElements.define('custom-select', CustomSelect);
}